import { Button, DatePicker, Select } from '@components/common';
import { RefreshCcw } from 'lucide-react';
import {
  ACCOUNTING_DASHBOARD_PERIOD_OPTIONS,
  AccountingDashboardPeriodPreset,
} from './accountingDashboard';

interface AccountingDashboardToolbarProps {
  scopeLabel: string;
  preset: AccountingDashboardPeriodPreset;
  dateFrom: string;
  dateTo: string;
  isRefreshing: boolean;
  onPresetChange: (value: AccountingDashboardPeriodPreset) => void;
  onDateFromChange: (value: string) => void;
  onDateToChange: (value: string) => void;
  onRefresh: () => void;
}

export function AccountingDashboardToolbar({
  scopeLabel,
  preset,
  dateFrom,
  dateTo,
  isRefreshing,
  onPresetChange,
  onDateFromChange,
  onDateToChange,
  onRefresh,
}: AccountingDashboardToolbarProps) {
  return (
    <div className="rounded-[24px] border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
        <div className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-pos-primary">
            Accounting overview
          </p>
          <h2 className="mt-1.5 text-xl font-semibold tracking-tight text-slate-950">
            Business performance
          </h2>
          <p className="mt-1.5 text-sm text-slate-500">{scopeLabel}</p>
        </div>

        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-[190px_150px_150px_auto_auto]">
          <Select
            label="Period"
            options={ACCOUNTING_DASHBOARD_PERIOD_OPTIONS}
            value={preset}
            onChange={(value) =>
              onPresetChange(value as AccountingDashboardPeriodPreset)
            }
          />
          <DatePicker
            label="From"
            mode="single"
            value={dateFrom}
            onChange={onDateFromChange}
            placeholder="Select start date"
          />
          <DatePicker
            label="To"
            mode="single"
            value={dateTo}
            onChange={onDateToChange}
            placeholder="Select end date"
          />
          <div className="flex items-end">
            <Button
              variant="outline"
              className="w-full"
              onClick={onRefresh}
              disabled={isRefreshing}
            >
              <RefreshCcw size={16} className="mr-2" />
              {isRefreshing ? 'Refreshing...' : 'Refresh'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
